import { toast } from 'react-toastify'
import styled from 'styled-components'

const ExplorerLink = styled.a`
  color: ${p => p.theme.colors.button.background};
  text-decoration: none;
`

export const toastTxSuccess = (digest: string) => {
  toast.success(
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div>Transaction successful!</div>
      <ExplorerLink
        href={`https://suivision.xyz/txblock/${digest}`}
        style={{ marginLeft: 'auto' }}
        target="_blank"
        rel="noreferrer"
      >
        View on explorer
      </ExplorerLink>
    </div>
  )
}

export const toastTxConstructionError = () => {
  toast.error(
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div>Error constructing transaction</div>
    </div>
  )
}

export const toastTxFailed = (digest?: string) => {
  toast.error(
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div>Transaction failed!</div>
      {digest && (
        <ExplorerLink
          href={`https://suivision.xyz/txblock/${digest}`}
          style={{ marginLeft: 'auto' }}
          target="_blank"
          rel="noreferrer"
        >
          View on explorer
        </ExplorerLink>
      )}
    </div>
  )
}
